<div
  class="xux-dnd-list-container"
  [class.isDrag-modal]="isDragModeObs | async"
  cdkDropListGroup
>
  <ng-container *ngFor="let colConfig of listColConfigs; trackBy: trackByKey">
    <div
      *ngIf="colConfig.items?.length > 0 || (isDragModeObs | async)"
      class="xux-dnd-list"
      [class.isDrag]="isDragModeObs | async"
      [id]="'xux-dnd-list-' + colConfig.key"
    >
      <h2 *ngIf="colConfig.title">{{ colConfig.title | translate}}</h2>
      <div
        class="xux-dnd-list-content"
        [id]="'xux-dnd-list-content-' + colConfig.key"
        cdkDropList
        [cdkDropListDisabled]="!(isDragModeObs | async)"
        [autoScrollDisabled]="true"
        [cdkDropListData]="colConfig.items"
        (cdkDropListDropped)="drop($event)"
      >
        <ng-container
          *ngFor="
            let item of colConfig.items;
            let itemIndex = index;
            trackBy: trackByKey
          "
        >
          <xux-dnd-item-container
            *ngIf="!item.hidden"
            cdkDrag
            [cdkDragData]="item"
            [data-index]="itemIndex"
            [id]="item.key"
            [cdkDragPreviewClass]="'xux-theme'"
            [componentRef]="getItemCompRef(item.key)"
          ></xux-dnd-item-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
